import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { AreaAtuacao } from '../domain/area-atuacao.model';

export class AreaAtuacaoSerializer extends DomainSerializer<AreaAtuacao> {}
